module.exports = __webpack_public_path__ + "static/media/gingel.b1d7308f.png";